import { useContext } from 'react';
import { RegistrationSettingsContext } from '../context/RegistrationSettingsContext';

/**
 * Hook to access registration settings from context
 * @returns Registration settings context value
 * @throws Error if used outside of RegistrationSettingsProvider
 */
export const useRegistrationSettings = () => {
  const context = useContext(RegistrationSettingsContext);

  if (context === undefined) {
    throw new Error(
      'useRegistrationSettings must be used within a RegistrationSettingsProvider',
    );
  }

  return context;
};
